<template>
  <v-app>
    <v-dialog v-model="modalOpen" persistent>
      <v-card>
        <v-card-title>
          Asignación de cita para paciente {{ patient.name }}</v-card-title
        >
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                ref="dialog"
                v-model="dateAssignModal"
                :return-value.sync="formAssignDate.date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formAssignDate.date"
                    label="Fecha"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formAssignDate.date"
                  :min="minDate"
                  :allowed-dates="allowedDates"
                  scrollable
                  locale="es"
                  first-day-of-week="1"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateAssignModal = false">
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(formAssignDate.date)"
                  >
                    Cerrar
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                ref="dialog2"
                v-model="timeAssignModal"
                :return-value.sync="formAssignDate.time"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formAssignDate.time"
                    label="Hora"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeAssignModal"
                  v-model="formAssignDate.time"
                  full-width
                  max="19:30"
                  min="10:00"
                  :format="'24hr'"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="timeAssignModal = false"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog2.save(formAssignDate.time)"
                    >Cerrar</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" dark @click="closeModal">
            <v-icon left>mdi-close</v-icon>
            Cerrar
          </v-btn>
          <v-btn color="green" dark @click="saveDate">
            <v-icon left> mdi-content-save </v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import * as moment from "moment";
export default {
  props: ["openModal", "patient"],
  data() {
    return {
      modalOpen: this.openModal,
      dateAssignModal: false,
      timeAssignModal: false,
      formAssignDate: {
        date: "",
        time: "",
      },
      minDate: moment().add(1, "day").format("YYYY-MM-DD"),
    };
  },
  methods: {
    allowedDates: (val) => ![6].includes(new Date(val).getDay()),
    closeModal() {
      this.modalOpen = false;
      this.$emit("close-modal");
    },
    saveDate() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl +
            "catalogs/patients/" +
            this.patient.id +
            "/dates",
          this.formAssignDate,
          "POST"
        );
        request
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.clearForm(this.formAssignDate);
            this.modalOpen = false;
            this.closeModal();
          })
          .finally(() => this.closeLoader());
      }, 200);
    },
  },
};
</script>